import * as React from "react";
// Styles
import { useScreenReaderOnlyStyles } from "./ScreenReaderOnly.styles";
// Utilities
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Component which hides its content from sighted users
 * Use for aria typed attributes
 */ export const ScreenReaderOnly = ({ children, customStyles })=>{
    const styles = customizeStyles(useScreenReaderOnlyStyles(), customStyles);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, children);
};
